import React from 'react';
import ProductCardList from 'components/NewHome/ProductCardList';
import MobileProductModuleList from 'components/NewHome/Mobile/MobileProductModuleList';
import { fluxProductsList } from 'helper/Home/productCardList';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function Flux() {
  if (useIsMobile()) {
    return <MobileProductModuleList title="FLUX" products={fluxProductsList} />;
  }

  return (
    <div className="dark-outlet-background">
      <h1 className="mb-5">FLUX</h1>
      <ProductCardList products={fluxProductsList} />
    </div>
  );
}
